import './Certificates.css';
import webdevm from '../assets/certificate/webdev.jpg'
import React from "react";
// import "./../index.css";
import { motion } from "framer-motion";
import coursera from '../assets/certificate/coursera.png'
import pirple from '../assets/certificate/pirple.png'
import linux from '../assets/certificate/linux.png'
import udemynode from '../assets/certificate/udemynode.png'
import udemydata from '../assets/certificate/udemydata.png'
import all from '../assets/certificate/naam.jpg'
import umjs from '../assets/certificate/modernjs.jpg'
import uhtml from '../assets/certificate/uhtml.jpg'
import dataSci from '../assets/certificate/dataSci.png'
import git from '../assets/certificate/git.png'
import free from '../assets/certificate/digi.png'

const boxVariants = {
  hover: {
    scale: 1.06,
    transition: {
      type: "spring",
    },
  },
};

const Certificates = () => {
  return (
    <section
      data-aos="fade-up"
      className="certificates-container"
      name="certificates"
      id="Certificates"
    >
      <h1 className="heading bb">Certificates</h1>
      <div className="projects-container">


            {/* Certification 2 - coursera */}
            <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={coursera}>
            <div className="project-images" id="coursera"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>AI for everyone</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://coursera.org/share/401616385dfc5c9a8eafe93e58b0b8ad"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}
        {/* Certification 1 - React Basic */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={webdevm}>
            <div className="project-images" id="webm"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3> Web Development Masterclass - Complete Certificate Course</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://www.udemy.com/certificate/UC-11b7df23-3a7d-43b7-afa0-99cfb7a266c9/?fbclid=IwAR3x47R6WfMlFSftJrIy1mMU7NQr9weIL_SxyL4rY0TbUJAPrfpqOoayJEw"
                target="_blank"
              >
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

    

        {/* Certification 3 - Cisco linux */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={linux}>
            <div className="project-images" id="ciscolinux"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Cisco International Linux Essential Certification</h3>
            </div>
            <div className="icons">
              <a rel="noopener noreferrer" href={linux} target="_blank">
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Certification 4 - pirple */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={pirple}>
            <div className="project-images" id="pirple"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Pirple frontend Certificate</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://api.accredible.com/v1/frontend/credential_website_embed_image/certificate/16109291"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}

        {/* Certification 5 - Specialization linux */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={udemydata}>
            <div className="project-images" id="udata"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Data Manipulation in python</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://udemy-certificate.s3.amazonaws.com/image/UC-8ef80296-4445-49cd-9d8a-50c2856354ef.jpg"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>
        {/* // */}
        {/* Certification 6 - Specialization linux */}
        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={udemynode}>
            <div className="project-images" id="unode"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Fundamentals of Node Js</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://udemy-certificate.s3.amazonaws.com/image/UC-7aecee03-d216-467d-866c-1854154c0537.jpg"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={dataSci}>
            <div className="project-images" id="dataSci"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Into to Data and Data science</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href={dataSci}
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={free}>
            <div className="project-images" id="free"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Free Lancing Training</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href={free}
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={git}>
            <div className="project-images" id="git"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Git and Github</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href={git}
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        


        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={all}>
            <div className="project-images " id="uall"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3> HTML, JavaScript, & Bootstrap - Certification Course</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://udemy-certificate.s3.amazonaws.com/image/UC-07f9eb82-55c6-48c3-8f62-cb7ec0e77f8d.jpg"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={umjs}>
            <div className="project-images" id="ujs"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3>Modern Javascript</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://udemy-certificate.s3.amazonaws.com/image/UC-2a3619bd-b617-49e7-a859-a2baa6ade755.jpg"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={boxVariants}
          whileHover="hover"
          className="projects"
        >
          <a rel="noopener noreferrer" target="_blank" href={uhtml}>
            <div className="project-images" id="uhtml"></div>
          </a>

          <div className="project-links">
            <div className="text nn">
              <h3> Learn HTML - For Beginners</h3>
            </div>
            <div className="icons">
              <a
                rel="noopener noreferrer"
                href="https://udemy-certificate.s3.amazonaws.com/image/UC-d6a91ff7-76d3-431a-a876-1c8c43dd2592.jpg"
                target="_blank"
              >
                {" "}
                <i
                  className="fas fa-external-link-alt"
                  title="url"
                  id="live"
                ></i>
              </a>
            </div>
          </div>
        </motion.div>

     
        {/* // */}
       
     
      </div>
    </section>
  );
};

export default Certificates;
